import React from 'react';
export function Guarantee() {
  return <section className=<div className="max-w-2xl mx-auto text-center" data-id="element-160">
        <div className="bg-white rounded-2xl p-8 md:p-10 border-2 border-green-300 shadow-lg" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-black font-heading text-gray-900 mb-6" data-id="element-162">
            🛡️ GARANTÍA 7 DÍAS
          </h2>

          <div className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-163">
            <div className="flex items-center gap-3" data-id="element-164">
              <div className="bg-green-100 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0" data-id="element-165">
                <span className="text-green-600 font-bold text-sm" data-id="element-166">1</span>
              </div>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-167">
                Abres los tomos
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-168">
              <div className="bg-green-100 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0" data-id="element-169">
                <span className="text-green-600 font-bold text-sm" data-id="element-170">2</span>
              </div>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-171">
                Revisas los bonos
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-172">
              <div className="bg-green-100 rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0" data-id="element-173">
                <span className="text-green-600 font-bold text-sm" data-id="element-174">3</span>
              </div>
              <p className="text-gray-700 font-body text-base md:text-lg" data-id="element-175">
                Lo aplicas si quieres
              </p>
            </div>
          </div>

          <div className="bg-green-50 rounded-xl p-6 border border-green-200" data-id="element-176">
            <p className="text-lg md:text-xl font-bold text-gray-900 font-heading mb-2" data-id="element-177">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-xl md:text-2xl font-black text-green-700 font-heading mb-4" data-id="element-178">
              👉 Te devolvemos el 100%
            </p>
            <p className="text-gray-600 font-body" data-id="element-179">Sin preguntas</p>
            <p className="text-gray-600 font-body" data-id="element-180">Sin vueltas</p>
          </div>
        </div>
      </div> data-id="element-159"></section>;
}